import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { getValue } from 'remote-config-value'
import PropTypes from 'prop-types'
import StepTitle from '../../StepTitle'
import { Checkbox, Typography } from 'foundations-library/components'
import RedAsterisk from '../../RedAsterisk'
import useDisableInput from '../../../hooks/useDisableInput'

const useStyles = makeStyles((theme) => ({
    mb5: {
        marginBottom: 5
    },
    mb15: {
        marginBottom: 15
    },
    checkboxesContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 20
    }
}))

/**
 * @param {object} props
 */
const Policies = (props) => {
    const campaignPoliciesData = props.passData.campaign_policies
    const classes = useStyles()

    const [checked, setChecked] = useState(campaignPoliciesData ? campaignPoliciesData.checked : null)
    const [checked2, setChecked2] = useState(campaignPoliciesData ? campaignPoliciesData.checked2 : null)
    const [checked3, setChecked3] = useState(campaignPoliciesData ? campaignPoliciesData.checked3 : null)

    const { disableAllInputs } = useDisableInput({ mode: props.mode, item: props.editing })

    const invalid = !checked || !checked2 || !checked3

    const getSaveData = () => {
        return {
            checked,
            checked2,
            checked3
        }
    }
    useEffect(() => {
        if (props.saveId) props.update({ completed: true, gotoNext: true, saveData: getSaveData() })
    }, [props.saveId])

    useEffect(() => {
        props.update({ disableNextButton: () => invalid })
    }, [invalid])

    return (
        <div>
            <StepTitle>
                {getValue('sms_enrollment_content_and_messaging')}
            </StepTitle>
            <div>
                <Typography variant='body1' remoteConfigID='sms_enrollment_policies_heading' className={classes.mb5} />
                <Typography variant='body4' className={classes.mb15}>
                    {getValue('sms_enrollment_policies_subtitle')}<RedAsterisk />
                </Typography>
            </div>
            <div className={classes.checkboxesContainer}>
                <Checkbox
                    variant='primary'
                    checked={checked}
                    disabled={disableAllInputs}
                    onChange={setChecked}
                    label={getValue('sms_enrollment_policies_checkbox_1')}
                />
                <Checkbox
                    variant='primary'
                    checked={checked2}
                    disabled={disableAllInputs}
                    onChange={setChecked2}
                    label={getValue('sms_enrollment_policies_checkbox_2')}
                />
                <Checkbox
                    variant='primary'
                    checked={checked3}
                    disabled={disableAllInputs}
                    onChange={setChecked3}
                    label={getValue('sms_enrollment_policies_checkbox_3')}
                />
            </div>
        </div>
    )
}

Policies.propTypes = {
    editing: PropTypes.object,
    passData: PropTypes.object,
    update: PropTypes.func,
    saveId: PropTypes.number,
    mode: PropTypes.string
}

export default Policies
